import {
  ChangeDetectionStrategy,
  Component,
  type Signal,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { OrganisationService } from '@principle-theorem/ng-principle-shared';
import {
  BreadcrumbsComponent,
  type IBreadcrumb,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import { PracticeSettings } from '@principle-theorem/principle-core';
import { AiReceptionistLandingComponent } from '../landing/ai-receptionist-landing.component';
import { AiReceptionistKnowledgeBaseEditorComponent } from './ai-receptionist-knowledge-base-editor.component';

@Component({
  selector: 'pr-ai-receptionist-settings',
  imports: [
    NgCommonModule,
    AiReceptionistKnowledgeBaseEditorComponent,
    AiReceptionistLandingComponent,
    BreadcrumbsComponent,
  ],
  templateUrl: './ai-receptionist-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiReceptionistSettingsComponent {
  private readonly _organisation = inject(OrganisationService);
  readonly practice = toSignal(this._organisation.practice$);
  readonly breadcrumbs: Signal<IBreadcrumb[]> = computed(() => {
    const practice = this.practice();
    if (!practice) {
      return [];
    }
    return [
      { label: 'Settings', path: '../../../' },
      { label: practice.name },
      { label: 'AI Receptionist' },
    ];
  });
  readonly isEnabled = computed(() => {
    const practice = this.practice();
    return practice
      ? PracticeSettings.isAiReceptionistEnabled(practice)
      : false;
  });
}
